<template>
<div class="overflow-y-scroll bg-gray-50 rounded-lg shadow-inner p-2 h-full order-2 lg:order-2" id="slidesWrapper">
  <div v-for="s, i in slides" v-bind:key="i" style="padding-bottom: 56.25%" class="relative w-full bg-black rounded-lg my-2 hover:opacity-100 border-2"
       :class="{'border-blue-600 opacity-100 currentSlide': currentSlideIndex === i, 'opacity-50': currentSlideIndex !== i}" v-on:click="goToSlide(i)">
    <div class="group absolute z-50 text-white w-full h-full">
      <div v-if="s.name !== undefined && s.name !== null" class="group-hover:block hidden bg-black px-2 py-1">{{s.name}}</div>
      <div v-else class="italic group-hover:block hidden bg-black px-2 py-1">No Title</div>
    </div>
    <img v-if="s.media_type === 'image'" class="absolute w-full h-full rounded-lg object-contain" :src="s.url">
    <div @click="goToSlide(i)" v-else-if="s.media_type === 'audio'" class="absolute w-full h-full bg-gray-900 slide-in-item col-span-1 rounded-lg overflow-hidden">
      <div class="relative">
        <img class="absolute inset-0 z-1 object-cover w-full h-full transform">
        <!-- Audio icon -->
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-1/2 text-white h-10 w-10 px-2 py-1" viewBox="0 0 20 20" fill="currentColor">
          <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
        </svg>
      </div>
    </div>
    <div @click="goToSlide(i)" v-else-if="s.media_type === 'video'" class="absolute w-full h-full bg-gray-900 slide-in-item col-span-1 rounded-lg overflow-hidden">
      <div class="relative">
        <img class="absolute inset-0 z-1 object-cover w-full h-full transform" />
        <!-- Video icon -->
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-1/2 text-white h-10 w-10 px-2 py-1" viewBox="0 0 20 20" fill="currentColor">
          <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
        </svg>
              </div>
            </div>
          </div>
        </div>
</template>
<script>

export default {
  name: "slides-manager",
  props: {
    slides: {},
    currentSlideIndex:{
      type: Number,
    }
  },
  methods: {
    goToSlide(index){
      if (index >= this.slides.length || 0 > index) return;
      this.$emit("update:current-slide-index", index);
    },
    scrollIntoViewIfNeeded(target) {
      if(target == null) return;
      if (target.getBoundingClientRect().bottom - target.parentElement.offsetHeight > -200) {
        const top = target.offsetTop;
        // target.parentElement.scroll({top: target.parentElement.100, left: 0, behaviour: "smooth"});
        target.parentElement.scrollTop  += top-500;
      }

      if (target.getBoundingClientRect().top - target.parentElement.getBoundingClientRect().top < 0) {
        target.parentElement.scrollTop  += top-10;
    }
}
  },
  watch:{
    currentSlideIndex(){
      this.scrollIntoViewIfNeeded(document.querySelector("#slidesWrapper .currentSlide"))
    }
  }
}

</script>
